import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IControls } from 'bi-interfaces';
import { BILookupComponent } from '../BI-Lookup/bi-lookup.component';

@Component({
  selector: 'bi-floating-lookup',
  templateUrl: './bi-floating-lookup.component.html',
  styleUrls: ['./bi-floating-lookup.component.scss','../BI-Lookup/bi-lookup.component.scss']
})
export class BiFloatingLookupComponent extends BILookupComponent {


  @Input() Control!: IControls;
  @Input() FormGroup!: FormGroup;

  @Input() override  DomID!: string;

}
